
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState } from 'react';
import { Tooltip, ClickAwayListener, makeStyles } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

import InfoIcon from './icons/icon.svg';

type Props = {
  customer_involvement: number;
  salesperson_involvement: number;
  pitchAuditScore: number;
  pitchAuditScoreConvCount: number;
};

const useStyles = makeStyles({
  touch: {
    fontSize: '0.55rem',
  },
  tooltip: {
    fontSize: '0.75rem',
  },
});

const InvolvementPitchQualityMetrics = (props: Props) => {
  const classes = useStyles();
  const {
    customer_involvement,
    salesperson_involvement,
    pitchAuditScore,
    pitchAuditScoreConvCount
  } = props;
  const [showDetailedConversationsTooltip, setShowDetailedConversationsTooltip] = useState<boolean>(false);
  const [showHighIntentContactsTooltip, setShowHighIntentContactsTooltip] = useState<boolean>(false);

  const handleDetailedConversationsClick = () => {
    setShowDetailedConversationsTooltip(!showDetailedConversationsTooltip);
  };

  const handleHighIntentContactsClick = () => {
    setShowHighIntentContactsTooltip(!showHighIntentContactsTooltip);
  };

  return (
    <div className="relative flex flex-col px-2 py-3 bg-background-white w-full max-w-xs min-w-[240px] lg:min-w-max rounded">
      <div className="flex items-center mb-2">
        <p className="text-sm leading-5 font-bold text-primary-grey ml-2">
          Talk-to-listen Ratio
        </p>
        <ClickAwayListener onClickAway={() => setShowDetailedConversationsTooltip(false)}>
          <div
            className="inline-flex items-center ml-1 mb-2"
            onMouseOver={
              isMobile
                ? () => {}
                : () => setShowDetailedConversationsTooltip(true)
            }
            onMouseLeave={
              isMobile
                ? () => { }
                : () => setShowDetailedConversationsTooltip(false)
            }
          >
            <Tooltip
              title="Percentage of time your contacts spoke across all your conversations"
              placement="bottom-end"
              arrow
              open={showDetailedConversationsTooltip}
              classes={{
                tooltip: classes.tooltip,
                touch: classes.touch,
              }}
              leaveDelay={1000}
              leaveTouchDelay={1000}
            >
              <button
                type="button"
                className="h-7 lg:h-5 w-7 lg:w-5 p-0 bg-transparent rounded-full cursor-pointer"
                onClick={handleDetailedConversationsClick}
              >
                <InfoIcon className="w-4 h-4 text-primary-grey fill-current cursor-pointer" />
              </button>
            </Tooltip>
          </div>
        </ClickAwayListener>
        <p className="text-sm leading-5 font-normal text-primary-dark ml-2 flex items-center">
          <span className="text-xl font-bold">
            {!(salesperson_involvement === 0 || customer_involvement === 0) ? (
              `${Number(salesperson_involvement)?.toFixed(0) || 0}:${Number(customer_involvement)?.toFixed(0) || 0}`
            ) : (
              '0:0'
            )}
          </span>
        </p>
      </div>

      <div className="flex items-center mb-1 mt-6">
        <p className="text-sm leading-5 font-bold text-primary-grey ml-2">
          Call Quality Score
        </p>
        <ClickAwayListener onClickAway={() => setShowHighIntentContactsTooltip(false)}>
          <div
            className="inline-flex items-center ml-1 mb-2"
            onMouseOver={
              isMobile
                ? () => {}
                : () => setShowHighIntentContactsTooltip(true)
            }
            onMouseLeave={
              isMobile
                ? () => {}
                : () => setShowHighIntentContactsTooltip(false)
            }
          >
            <Tooltip
              title="Call Quality Score is the avg. score on parameters set for call quality standards."
              placement="bottom-end"
              arrow
              open={showHighIntentContactsTooltip}
              classes={{
                tooltip: classes.tooltip,
                touch: classes.touch,
              }}
              leaveDelay={1000}
              leaveTouchDelay={1000}
            >
              <button
                type='button'
                className="h-7 lg:h-5 w-7 lg:w-5 p-0 bg-transparent rounded-full cursor-pointer"
                onClick={handleHighIntentContactsClick}
              >
                <InfoIcon className="w-4 h-4 text-primary-grey fill-current cursor-pointer" />
              </button>
            </Tooltip>
          </div>
        </ClickAwayListener>
        <p className="text-sm leading-5 font-normal text-primary-dark ml-2 flex flex-col justify-center">
          <span className="text-xl font-bold">
            {pitchAuditScore && !Number.isNaN(Number(pitchAuditScore)) ? `${Math.round(Number(pitchAuditScore))}%` : '-'}
          </span>
        </p>
      </div>
      {pitchAuditScoreConvCount && (
        <span className='ml-auto text-xs text-secondary'>
          {pitchAuditScoreConvCount} conversation{pitchAuditScoreConvCount > 1 ? 's' : ''}
        </span>
      )}
    </div>
  );
};

export default InvolvementPitchQualityMetrics;